import { Align, Offset, Popup } from "@progress/kendo-react-popup";
import React from "react";

export interface CustomPopupProps {
	style?: React.CSSProperties;
	children?: React.ReactNode;
	onClose: () => void;
	show: boolean;
	anchor: React.RefObject<any>;
	anchorAlign?: Align;
	popupAlign?: Align;
	offset?: Offset;
}

const CustomPopup: React.FC<CustomPopupProps> = ({
	anchor,
	show,
	style,
	children,
	onClose,
	anchorAlign = {
		vertical: "bottom",
		horizontal: "center",
	},
	popupAlign = {
		vertical: "bottom",
		horizontal: "center",
	},
	offset,
}) => {
	return (
		<Popup
			anchor={anchor.current}
			show={show}
			onClose={onClose}
			style={style}
			anchorAlign={anchorAlign}
			popupAlign={popupAlign}
			offset={offset}
		>
			<div>{children}</div>
		</Popup>
	);
};

export default CustomPopup;
